import { render } from "./RoamingTeamDetail.vue?vue&type=template&id=2dbe1880&scoped=true"
import script from "./RoamingTeamDetail.vue?vue&type=script&lang=js"
export * from "./RoamingTeamDetail.vue?vue&type=script&lang=js"

import "./RoamingTeamDetail.vue?vue&type=style&index=0&id=2dbe1880&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbe1880"]])

export default __exports__